import { Box, Modal, Typography, Input, Button } from "@material-ui/core";
import { TextField } from "@mui/material";
import React, { useEffect } from "react";
import CopyToClipboard from "react-copy-to-clipboard";
import { LinkPagamento } from "../../../../../model/model";
import CopyBlue from "../../../../../img/content_copy_blue.svg";
import * as S from "./modalInfoStyles";
interface ModalInfoProps {
  modalVisible: boolean;
  setModalVisible(b: boolean): void;
  //type: string;
  sendEmailSmsWhats(type: string, content: any): Promise<boolean>;
  createdLink: LinkPagamento;
  defaultSelectedType?: string;
}

export default function ModalInfo({
  modalVisible,
  setModalVisible,
  //type,
  sendEmailSmsWhats,
  createdLink,
  defaultSelectedType,
}: ModalInfoProps) {
  const [inputText, setInputText] = React.useState("");
  const [inputTextEmail, setInputTextEmail] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const [types, setTypes] = React.useState<string[]>([]);

  const [visible, setVisible] = React.useState(false);

  useEffect(() => {
    if (modalVisible) {
      setVisible(true);
    }
  }, [modalVisible]);

  useEffect(() => {
    if (defaultSelectedType) {
      if (types.length === 0) {
        setTypes([defaultSelectedType]);
      }
    }
  }, [defaultSelectedType]);

  function close() {
    setVisible(false);

    setTimeout(() => {
      if (setModalVisible) {
        setModalVisible(false);
      }
    }, 300);
  }

  function maskPhone(preValue: string): string {
    let value = preValue;
    value = value.replace(/\D/g, "");
    //(00) 00000-0000 / (00) 0000-0000

    /*if (value.length <= 11) {
			value = value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, '$1.$2.$3-$4');
		} else {
			value = value.replace(
				/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g,
				'$1.$2.$3/$4-$5'
			);
		}*/

    if (value.length <= 10) {
      value = value.replace(/(\d{2})(\d{4})(\d{4})/g, "($1) $2-$3");
    } else {
      value = value.replace(/(\d{2})(\d{5})(\d{4})/g, "($1) $2-$3");
    }

    return value;
  }

  const [sucesso, setSucesso] = React.useState(false);
  const [erro, setErro] = React.useState(false);

  async function sendInfo(type: string) {
    try {
      const to =
        type === "mail" ? inputTextEmail : inputText.replace(/\D/g, "");
      const message =
        type === "sms"
          ? `AME: Link para pagamento: ${`${process.env.REACT_APP_LINK_REDIRECT}pagamento/link/${createdLink.id}?secret=${createdLink.secret}`}`
          : `Olá, ${
              createdLink.pagamento?.cliente
            }, segue o link para pagamento como solicitado. O link para o pagamento é ${`${process.env.REACT_APP_LINK_REDIRECT}pagamento/link/${createdLink.id}?secret=${createdLink.secret}`}.`;
      if (to.length === 0) {
        return true;
      }
      if (type === "mail" && !to.includes("@")) {
        return true;
      }
      if (type !== "mail" && to.length < 8) {
        return true;
      }
      let numberConvert = ''

      if(type !== 'mail'){
        if(to.length===11 && type === 'whatsapp'){
          numberConvert = `+55${to.substring(0, 3) + to.substring(3+1)}`
        }else{
          numberConvert=`+55${to}`
        }
      }

      const content =
        type === "mail"
          ? {
              to,
              message,
              from: process.env.REACT_APP_PAGE_TITLE || "",
              subject: `Link de pagamento ${`${
                process.env.REACT_APP_PAGE_TITLE || ""
              }`}`,
            }
          : {
              to:numberConvert,
              body: message,
            };
      const response = await sendEmailSmsWhats(type, content);

      if (response) {
        return false;
      } else {
        return true;
      }
    } catch (error) {
      console.log(error);
      return true;
    }
  }

  async function onSubmit() {
    if (loading) return;
    setLoading(true);
    let err = false;
    let i = 0;
    console.log(types);
    for (i = 0; i < types.length; i++) {
      const response = await sendInfo(types[i]);
      if (response) {
        err = response;
      }
    }

    if (err) {
      setErro(true);
      setTimeout(() => {
        setErro(false);
      }, 5000);
    } else {
      setSucesso(true);
      setTimeout(() => {
        setSucesso(false);
      }, 5000);
    }

    setLoading(false);
  }

  function onClickType(t: string) {
    const findex = types.findIndex((ty) => ty === t);
    if (findex !== -1) {
      const newT = [...types];
      newT.splice(findex, 1);
      setTypes([...newT]);
    } else {
      setTypes([...types, t]);
    }
  }

  return (
    <S.Modal
      active={modalVisible}
      visible={visible}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        close();
      }}
    >
      <S.Container
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
        }}
      >
        <div className="modal_container_header">
          <p className="modal_container_header_title">Enviar link</p>
          <Button
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              close();
            }}
            className="modal_container_header_button"
          >
            Fechar
          </Button>
        </div>
        <div className="modal_container_body">
          <div className="modal_container_body_user">
            <span>
              {createdLink &&
              createdLink.pagamento &&
              createdLink.pagamento.cliente
                ? createdLink.pagamento?.cliente
                : "-"}
            </span>
            <span>{`UC ${
              createdLink && createdLink.pagamento && createdLink.pagamento.uc
                ? createdLink.pagamento?.uc
                : "-"
            }`}</span>
          </div>
          <CopyToClipboard
            text={`${process.env.REACT_APP_LINK_REDIRECT}pagamento/link/${createdLink.id}?secret=${createdLink.secret}`}
          >
            <div
              style={{ marginTop: "8px" }}
              className="modal_container_body_link"
            >
              <img alt="copy" src={CopyBlue} />
              <p>
                {`${process.env.REACT_APP_LINK_REDIRECT}pagamento/link/${createdLink.id}?secret=${createdLink.secret}`}
              </p>
            </div>
          </CopyToClipboard>

          <div
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              if (!(types.includes("whatsapp") || types.includes("sms")))
                onClickType("whatsapp");
            }}
            className="modal_container_block"
          >
            <div className="modal_container_block_header">
              <div className="modal_container_block_header_first">
                <div
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    if (
                      !(types.includes("whatsapp") || types.includes("sms"))
                    ) {
                      onClickType("whatsapp");
                    } else {
                      if (types.includes("whatsapp")) {
                        onClickType("whatsapp");
                      }

                      if (types.includes("sms")) {
                        onClickType("sms");
                      }
                    }
                  }}
                  className={`modal_container_block_header_first_circle ${
                    types.includes("whatsapp") || types.includes("sms")
                      ? "modal_container_block_header_first_circle_selected"
                      : ""
                  }`}
                />
                <p className="modal_container_block_header_first_title">
                  Enviar para celular
                </p>
              </div>
              <div className="modal_container_block_header_last">
                <div
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    onClickType("whatsapp");
                  }}
                  className="modal_container_block_header_last_item"
                >
                  <div
                    className={`modal_container_block_header_last_item_block ${
                      types.includes("whatsapp")
                        ? "modal_container_block_header_last_item_block_on"
                        : ""
                    }`}
                  />
                  <p>Whatsapp</p>
                </div>
                <div
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    onClickType("sms");
                  }}
                  className="modal_container_block_header_last_item"
                >
                  <div
                    className={`modal_container_block_header_last_item_block ${
                      types.includes("sms")
                        ? "modal_container_block_header_last_item_block_on"
                        : ""
                    }`}
                  />
                  <p>SMS</p>
                </div>
              </div>
            </div>

            <TextField
              label="Celular"
              style={{ marginTop: "16px", width: "100%" }}
              key="type_input"
              value={inputText}
              onChange={(e) => {
                setInputText(maskPhone(e.target.value));
              }}
              type={"tel"}
              placeholder={"(99) 99999-9999"}
            />
          </div>

          <div
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              if (!types.includes("mail")) onClickType("mail");
            }}
            className="modal_container_block"
          >
            <div className="modal_container_block_header">
              <div className="modal_container_block_header_first">
                <div
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    onClickType("mail");
                  }}
                  className={`modal_container_block_header_first_circle ${
                    types.includes("mail")
                      ? "modal_container_block_header_first_circle_selected"
                      : ""
                  }`}
                />
                <p className="modal_container_block_header_first_title">
                  Enviar para e-mail
                </p>
              </div>
            </div>

            <TextField
              label="E-mail"
              name="Email"
              style={{ marginTop: "16px", width: "100%" }}
              key="type_input"
              value={inputTextEmail}
              onChange={(e) => {
                setInputTextEmail(e.target.value);
              }}
              type={"email"}
              placeholder={"email@email.com"}
            />
          </div>
          <Button
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              if (types.length > 0) onSubmit();
            }}
            style={{
              background: types.length > 0 ? "#28A745" : "#f0f0f0",
              height: "42px",
              paddingLeft: "12px",
              paddingRight: "12px",
              textTransform: "none",
              font: "normal normal normal 20px/24px Roboto",
              color: types.length > 0 ? "#ffffff" : "#888888",
              borderRadius: "16px",
              marginTop: "16px",
              width: "100%",
            }}
          >
            {loading
              ? "Enviando"
              : sucesso
              ? "Enviado com sucesso"
              : erro
              ? "Falha no envio"
              : "Enviar"}
          </Button>
        </div>
      </S.Container>
    </S.Modal>
  );
}

interface ModalProps {
  active?: boolean;
  setActive?(b: boolean): void;
  hash?: string;
  clear?(): void;
}

function ModalLimparCaixa({ active, hash, setActive, clear }: ModalProps) {}
